import { render, staticRenderFns } from "./AdditionalFieldsNumber.vue?vue&type=template&id=cf839b98&scoped=true&lang=pug&"
import script from "./AdditionalFieldsNumber.vue?vue&type=script&lang=ts&"
export * from "./AdditionalFieldsNumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf839b98",
  null
  
)

export default component.exports